/**
 * Premium feature gating (FE half — the BE enforces the same on its gated
 * endpoints). After onboarding a user can browse the app shell for free, but
 * the functional features below require an active subscription. The home
 * dashboard, billing, profile, and the paywall/automation flows stay free so a
 * non-subscriber can still navigate, see their account, and subscribe.
 *
 * Keys match the nav `id` / route segment used in the Sidebar and AppLayout
 * routes (see `src/components/layout/Sidebar.tsx` and `AppLayout.tsx`).
 */
const PREMIUM_FEATURES: ReadonlySet<string> = new Set([
  'chat',
  'content-review',
  'calendar',
  'knowledge-base',
  'topic-trends',
  'market-news',
  'preferences',
  'channels',
  'create-post',
  'competitors',
]);

/** True when the given page/nav key requires an active subscription. */
export function isPremiumFeature(page: string): boolean {
  return PREMIUM_FEATURES.has(page);
}

/** Human-readable label for the upgrade prompt, keyed off the nav id. */
const FEATURE_LABELS: Record<string, string> = {
  chat: 'Agent LiLi',
  'content-review': 'Review Queue',
  calendar: 'Calendar',
  'knowledge-base': 'Knowledge Base',
  'topic-trends': 'Social Listening',
  'market-news': 'Market News',
  preferences: 'Brand DNA',
  channels: 'Channels',
  'create-post': 'Create Post',
  competitors: 'Competitors',
};

export function featureLabel(page: string): string {
  return FEATURE_LABELS[page] ?? 'This feature';
}
